import { render } from "./HeroLoading.vue?vue&type=template&id=ebc87062&scoped=true"
const script = {}

import "./HeroLoading.vue?vue&type=style&index=0&id=ebc87062&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ebc87062"]])

export default __exports__